<template>
  <dl class="catalog__category-sub-categories" :class="{'catalog__category-subcategories': horizontal}" v-if="sortedSubCategories.length">
    <dt @click="toggleFilter()" :class="filterOpen ? '_visible' : ''">{{ $t('Subcategorie') }}</dt>
    <dd v-show="filterOpen">
      <div class="slider__container">
        <ul>
          <li v-for="(subCategory, index) in sortedSubCategories" v-show="filterIsVisibleCheck(index, subCategory)">
            <a :href="subCategory['url_key']" :class="{ '--active': isActive(subCategory) }">{{ subCategory.name }}</a>
          </li>
        </ul>
        <a v-if="hasHiddenSubCategories" href="#" @click.prevent.stop="toggleFilterValueCollapse()" class="_button _small">
          <span v-if="filterCollapsed">{{ $t('Show more') }}</span>
          <span v-else>{{ $t('Show less') }}</span>
        </a>
      </div>
    </dd>
  </dl>
</template>

<script lang="ts">
  import {Component, Vue, Prop} from 'vue-property-decorator';
  import {directive, Swiper, SwiperSlide} from "vue-awesome-swiper";

  @Component({
    name: 'sub-categories',
    components: {
      Swiper,
      SwiperSlide
    },
    directives: {
      swiper: directive
    }
  })

  export default class extends Vue {
    @Prop({default: false}) readonly horizontal: boolean;
    @Prop({default: 0}) readonly categoryId: Number;
    @Prop({default: []}) readonly subCategories: Array<object>;

    readonly filtersToShow: number = 5;
    private filterCollapsed: boolean = false;
    private filterOpen: boolean = true;

    private created(): void {
      this.filterCollapsed = this.hasHiddenSubCategories;
    }

    private get hasHiddenSubCategories(): boolean {
      return this.sortedSubCategories.some((subCategory, index) => {
        return index >= this.filtersToShow && !this.isActive(subCategory);
      });
    }

    private toggleFilter(): void {
      this.filterOpen = !this.filterOpen;
    }

    private toggleFilterValueCollapse(): void {
      this.filterCollapsed = !this.filterCollapsed;
    }

    private filterIsVisibleCheck(index, subCategory): boolean {
      return !this.filterCollapsed || index < this.filtersToShow || this.isActive(subCategory);
    }

    private get sortedSubCategories(): Array<object> {
      return this.subCategories.sort((a, b) => {
        return a['position'] - b['position'];
      });
    }

    private isActive(subCategory): boolean {
      if (this.categoryId == subCategory.category_id) {
        return true;
      }

      const children = subCategory['subcategories'] || [];
      return children.some((child) => this.categoryId == child.category_id);
    }
  }
</script>
